import { chakra } from '@chakra-ui/react';
import * as React from 'react';

const parseHighlightedHtml = (
  value: string
): Array<{ value: string; isHighlighted: boolean }> => {
  const normalizedValue = value
    .replace(/<ais-highlight-[^>]*>/g, '<em>')
    .replace(/<\/ais-highlight-[^>]*>/g, '</em>')
    .replace(/<mark[^>]*>/gi, '<em>')
    .replace(/<\/mark>/gi, '</em>');

  if (!normalizedValue.includes('<em>')) {
    return [{ value: normalizedValue, isHighlighted: false }];
  }

  return normalizedValue
    .split(/(<em>.*?<\/em>)/g)
    .filter(Boolean)
    .map((part) => ({
      value: part.replace(/<\/?em>/g, ''),
      isHighlighted: part.startsWith('<em>') && part.endsWith('</em>'),
    }));
};

export const OpenSearchText: React.FC<{ value: string }> = ({ value }) => (
  <span>
    {parseHighlightedHtml(value).map((part, index) =>
      part.isHighlighted ? (
        <chakra.span key={index} bg="blue.100">
          {part.value}
        </chakra.span>
      ) : (
        <span key={index}>{part.value}</span>
      )
    )}
  </span>
);

